<template>
    <!--
        Planning general
    -->

    <div class="row" style="justify-content: center; margin: 0">
        <div v-if="spinner" class="spinner"></div>
        <div v-show="!ocultar" class="col-md-12" @mousedown="cerrarop()" :style="difuminado">
            <vue-cal @click="sacarmes()" id="calendarioid" :snapToTime="30" min-event-width="50" sticky-split-labels
                :min-split-width="minevent" :locale="local" @view-change="prueba" v-model:active-view="vistaactiva"
                :dblclick-to-navigate="clickparanavegar" :timeStep="mitimestep" :split-days="splitDays"
                events-count-on-year-view :disableViews="disabledViews" :timeCellHeight="alturatimecel" ref="vuecal"
                :timeFrom="((propiedadescalendario.planning_hora_ini)*60)-60"
                :timeTo="((propiedadescalendario.planning_hora_fin)*60)+60" todayButton="true"
                :events-on-month-view="false" @cell-dblclick="eventoclick($event), cargarevs($event)"
                :events-on-week-view="[true, 'short']" hide-content-bar
                @event-duration-change="confirmarevento($event,'redimensiona')" :on-event-click="onEventClick"
                :events="eventos" @event-drop="confirmarevento($event,'arrastra')" :editable-events="editable"
                @event-delete="eliminarVisita($event)" :selected-date="selectedDate">
                <template   v-slot:event="{ event }">
                    <span @mouseover="mostrar($event,event)" @mouseleave="cerrarop()" class="vuecal__flex vuecal__cell-content"
                        :style='"background-color:" + event.color + ";border:1px solid #000;color:black" +"display:block"'>
                        <div style="text-align:center"
                            v-if="event.title == 'GUARDIA' || event.title == 'OCUPADO' || event.title == 'BLOQUEADO' || event.title == 'VACACIONES' || event.title == 'RESERVA'">
                            {{event.title}}
                        </div>
                        <div v-else-if="event.color == '#ffe88c' || event.color=='#E8EFF4'"
                            style="font-size:0.8em;font-weight:bold">
                            <!-- {{ decode_utf8(event.content.substring(0, event.content.indexOf(pepe))) }} -->
                            {{ decode_utf8(event.poblacion) }}&nbsp;<span v-if="event.cp"
                                :style="'background-color:' + event.color_km +'!important'">({{ event.cp }})</span>
                        </div>
                        <div v-else style="font-size:0.8em;font-weight:bold;color:white">
                            {{ decode_utf8(event.poblacion) }}&nbsp;<span v-if="event.cp"
                                :style="'background-color:' + event.color_km">({{ event.cp }})</span>
                        </div>
                    </span>
                </template>
                <template #time-cell="{ hours, minutes }">
                    <div v-if="hours<propiedadescalendario.planning_hora_ini"></div>
                    <div v-if="hours>=propiedadescalendario.planning_hora_ini && minutes!='00'"
                        class="vuecal__time-cell-line miclaseplanning">
                        <span v-if="minutes!=30 && minutes != 45 && minutes != 15 && hours<10">0{{ hours }}:{{ minutes
                            }}0</span>
                        <span v-if="minutes!=30 && minutes != 45 && minutes != 15 && hours>=10">{{ hours }}:{{ minutes
                            }}0</span>

                    </div>
                    <div v-if="hours>=propiedadescalendario.planning_hora_ini && minutes=='00'"
                        class="vuecal__time-cell-line miclaseplanningdos">
                        <span v-if="minutes!=30 && minutes != 45 && minutes != 15 && hours<10">0{{ hours }}:{{ minutes
                            }}0</span>
                        <span v-if="minutes!=30 && minutes != 45 && minutes != 15 && hours>=10">{{ hours }}:{{ minutes
                            }}0</span>

                    </div>

                </template>
                <template #split-label="{ split }">
                    <table class="mitabla123">
                        <tr>
                            <td style="line-height: 20px;">
                                <!--<strong :style="`color: ${split.color}`">{{ split.label.toString().toUpperCase() }}</strong></td></tr>-->
                                <i v-if="split.autovisita == 1" title="Operario configurado para Autovisita"
                                    class="fas fa-regular fa-lightbulb" :style="`color: rgb(225, 225, 1)`"></i>
                                &nbsp;<strong>{{ split.label.toString() }}</strong>
                            </td>
                        </tr>

                        <tr v-if="split.guardia == 1">
                            <td>
                                <strong>[GUARDIA]</strong>
                            </td>
                        </tr>
                        <tr v-if="split.interpwgs == 1">
                            <td>
                                <strong>[INTERPWGS]</strong>
                            </td>
                        </tr>
                        <tr v-if="split.preferente == 1">
                            <td>
                                <strong>[preferente]</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align:center">
                                <i v-if="split.observaciones" :title="' Observaciones\n' + split.observaciones"
                                    class="pi pi-exclamation-triangle" :style="`color: #f00`"></i>
                                <!--<strong :title="$t('general.Carga')" :style="`color: ${split.color}`">[{{ split.carga }}%]</strong>-->
                                <strong :title="$t('general.Carga')">[{{ split.carga }}%]</strong>
                                <a href="#" :title="$t('general.Llamar')" :onclick="split.clicktocall"><i
                                        class="pi pi-phone"></i></a>
                            </td>
                        </tr>
                    </table>
                </template>
                <template #title="{ title }">

                    <!-- <span style="color:black"><i @click="$refs.vuecal.previous()" class="fas fa-angle-left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i></span>-->
                    <div @click.stop="togglecalen($event)" :style="'color:black;' + colorfestivo">
                        {{ title }}&nbsp;&nbsp;{{nombrefestividad}}
                    </div>
                    <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:black"><i @click.stop="$refs.vuecal.next()" class="fas fa-angle-right"></i></span>-->
                    <OverlayPanel :dismissable="true" ref="calenddos">

                        <Calendar showOtherMonths="true" selectOtherMonths="true" v-model="fechacalddos" inline />

                    </OverlayPanel>
                </template>
                <template #events-count="{ events }">
                    <span v-for="event in events" :key="event">
                        <!--<span v-for="festivo in listadofestivos" :key="festivo">
                        <span v-if="event.fecha == festivo.title && event == events[0]"  class="badge badge-success"  style="font-size:medium;color:black">
                       <b> &nbsp;Festivo&nbsp;</b></span>
                    </span>-->
                        <span title="Activas" class="badge badge-primary" v-if="event.activas>0 && event == events[0]"
                            style="font-size:medium;background-color:#ffe88c;color:black">
                            <b> &nbsp;{{ event.activas }}&nbsp;</b>

                        </span>
                        <span title="Por confirmar" class="badge badge-primary"
                            v-if="event.confirmar>0 && event == events[0]"
                            style="font-size:medium;background-color:#f89393;color:black">
                            <b>&nbsp;{{ event.confirmar }}&nbsp;</b>

                        </span>
                        <span title="Finalizadas" class="badge badge-primary"
                            v-if="event.finalizadas>0 && event == events[0]"
                            style="font-size:medium;background-color:#e8eff4;color:black">
                            <b> &nbsp;{{ event.finalizadas }}&nbsp;</b>
                        </span>
                        <span :title="'Festivo: ' + event.festivostitle" class="badge badge-primary"
                            v-if="event.festivos && event == events[0]"
                            style="font-size:medium;background-color:#126e12;color:white">
                            <b> &nbsp;F&nbsp;</b>
                        </span>

                    </span>
                </template>
            </vue-cal>
            <OverlayPanel ref="opb" :showCloseIcon="false"><!---->
                <p>{{ descripcionbloq }}</p>
            </OverlayPanel>
            <OverlayPanel @hide="recargar()" ref="op" v-show="!noesguardiaofestivo" style="width:600px"
                :showCloseIcon="false"><!---->
                
                
                    <b>{{ nombreevento }}</b>&nbsp;<span v-if="distanciaevento && distanciaevento>0">Dist: </span><span
                        v-if="distanciaevento && distanciaevento > 0">{{distanciaevento}}&nbsp;Km</span>
                    <p v-html="descripcionevento"></p>
                    <div v-if="cargandoOver.length > 0">
                        <p style="text-align: center"><i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i></p>
                    </div>
                    <div v-else>
                        <servicio-datos-visitas-visita @cargarplanning="cargar()" :chatsvisita="chatsvisita" :planning="1"
                            :visita="eventoamostrar" v-if="eventoamostrar" :colorbotondos="colorbotondos"
                            :colorbotontres="colorbotontres" @recargar="recargar" :colorbotoncuatro="colorbotoncuatro"
                            :colorboton="colorboton" :servicio="servicio" :id="id" :propsplanning="false" />
                    </div>
                    <!-- <button type="button" v-show="eventoamostrar.visita && eventoamostrar.visita.confirmar==1"
                        @click="confirmarvisita(eventoamostrar)" title="Confirmar Visita" class="btn btn-default ">
                        <i class="fas fa-align-justify"></i>
                    </button>
                    <button type="button" class="btn btn-default " v-on:click='abrirventana' title="Parte Genérico">
                        <i class="far fa-file"></i>
                    </button>
                    <button type="button" class="btn btn-default " v-on:click="finalizarvisita()"
                        :style="'background:' + colorbotoncuatro" title="Finalizar Visita">
                        <i class="fas fa-check"></i>
                    </button>
    
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                        <i class="fas fa-share-square"></i>
                    </button>
    
                    <ul class="dropdown-menu">
                        <li class="dropdown-item"><a href="#" @click="parteoperarioemail()">{{$t('general.enviarfichaemail')
                                }}</a></li>
                        <li class="dropdown-divider"></li>
                        <li class="dropdown-item"><a href="#" @click="smsoperario()">{{ $t('general.smsaloperario') }}</a>
                        </li>
                        <li class="dropdown-item"><a href="#" @click="smsasegurado()">{{ $t('general.smsalasegurado') }}</a>
                        </li>
                        <li class="dropdown-item"><a href="#" @click="steasegurado()">{{ $t('general.firmasteemail') }}</a>
                        </li>
                    </ul>-->
               
            </OverlayPanel>
        </div>
        <div v-show="ocultar" class="alert alert-danger" role="alert">
            <h4>No hay operarios disponibles con los filtros seleccionados</h4>
        </div>
    </div>
    <Dialog ref='dialog1' @after-hide="recargar()" :draggable="false" v-model:visible="visible" v-show="visible" modal
        :header="titulo" :style="{ width: altura }">
        <!--'50vw'-->
        <p v-html="decode_utf8(infoevento)"></p>
        <servicio-datos-visitas-visita :planning="1" @cerrar="visible=false" :visita="eventoamostrar"
            v-if="eventoamostrar" :colorbotondos="colorbotondos" :colorbotontres="colorbotontres"
            :colorbotoncuatro="colorbotoncuatro" :colorboton="colorboton" :servicio="servicio" :id="id"
            @recargar="recargar" />
        <div class="row" v-if="editar == true" style="background:#c7f08b61">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="ffinidos">{{ $t('general.FechaInicio') }}</label><br>
                    <Calendar id="ffinidos" v-model="fechainicioeditar" :stepMinute="10" showTime hourFormat="24"
                        dateFormat="dd/mm/yy" />
                    <div class="custom-control custom-checkbox"> <br>
                        <input v-model="nomodificar" class="custom-control-input" type="checkbox" id="nomodificar"
                            true-value="1" false-value="0">
                        <label for="nomodificar" class="custom-control-label">{{ $t('general.nomodificar') }}</label>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="fechafindos">{{ $t('general.fechafin') }}</label><br>
                    <Calendar id="fechafindos" v-model="fechafineditar" showTime :stepMinute="10"
                        dateFormat="dd/mm/yy" />
                    <div class="custom-control custom-checkbox"> <br>
                        <input v-model="prioritaria" class="custom-control-input" type="checkbox" id="prioritaria"
                            true-value="1" false-value="0">
                        <label for="prioritaria" class="custom-control-label">{{ $t('general.prioritaria') }}</label>
                    </div>
                </div><br><br>
                <Button
                    @click="modificarVisita(eventoamostrar,fechainicioeditar,fechafineditar,infoevento,nomodificar,prioritaria)">{{
                    $t('general.guardar') }}</Button>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="descripcion">{{ $t('general.descripcion') }}</label>
                    <span class="p-float-label">
                        <Textarea autoResize v-model="infoevento" class="descripcion" />
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                </div>
            </div>
        </div>
        <div class="row" v-if="finalizar == true">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header bg-gray">
                        <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>{{ $t('finalizarvisita') }}
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="trabajosrealizados">{{$t('trabajosrealizados')}}</label>
                                    <textarea v-model="trabajosrealizadostexto" class="form-control" rows="10" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="trabajospendientes">{{ $t('trabajospendientes') }}</label>
                                <textarea v-model="trabajospendientestexto" class="form-control" rows="10" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                            </div>
                            <div class="col-md-2">
                                <button class="btn btn-success btn-block" @click="finVisita()" type="button">Finalizar
                                    Visita</button>
                            </div>
                            <div class="col-md-5">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="row"  v-if="editar == true" style="background:#c7f08b61"><div class="col-md-5"></div> <Button>{{ $t('general.guardar') }}</Button> </div>-->
        <planningcomunicaciones :id="eventoamostrar.visita.servicios_idservicios"
            :idvisita="eventoamostrar.visita.idvisitador" v-if="mostrarcomunicaciones" />
        <trabajosrealizadosoperarios v-if="eventoamostrar && trabajos" :operariosingular="operariosingular"
            :servicio="servicio" :totalrent="totalrent" :ocultarcliente="ocultarcliente"
            :ocultaroperario="ocultaroperario" :totalcliente="totalcliente" :totaloperario="totaloperario"
            :id="eventoamostrar.visita.servicios_idservicios" />
        <presupuestos v-if="presupuestos==true" :id="eventoamostrar.visita.servicios_idservicios" />
    </Dialog>
    <Dialog header="¿Quieres modificar la cita?" draggable="false" :style="{ width: '25rem' }"
        @hide="confirmacionvisible = false;recargar(); difuminado = ''" ref='dialogconfirmacion'
        v-show="confirmacionvisible" v-model:visible="confirmacionvisible" modal>
        <div class="row">
            <div class="col-md-12">
                <h5 class="text-center"><b>{{ eventoamodificar.event.title }}</b></h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <b>Original:</b> {{ new Date(eventoamodificar.originalEvent.start).addHours(1).toLocaleString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                })}} hasta {{ new Date(eventoamodificar.originalEvent.end).addHours(1).toLocaleTimeString() }}<br>
                <b>Nuevo:</b> {{ this.$refs.vuecal.view.startDate.toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                })}}, {{ new Date(eventoamodificar.event.start).addHours(1).toLocaleTimeString() 
                }} hasta {{ new Date(eventoamodificar.event.end).addHours(1).toLocaleTimeString() }}
            </div>
        </div>
        <div class="row mt-2">
            <div v-if="ipas && razones?.length>0">
                <h3 style="margin-top: 30px;text-align: center;">Comunicación con IPAS</h3>
                <div class="form-group">
                    <label for="idrazon">Razón:</label>
                    <select v-model="razonipas" class="form-control" id="idrazon">
                        <option value="">--------</option>
                        <option v-for="razon in razones" :key="razon.valor" :value="razon.valor">{{ razon.texto }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="subrazon">Sub-Razón:</label>
                    <select :disabled="razonipas == ''" v-model="subrazonipas" class="form-control" id="subrazon">
                        <option value="">--------</option>
                        <option v-for="subrazon in subrazones" :key="subrazon.valor" :value="subrazon.valor">{{ subrazon.texto }}</option>
                    </select>
                </div>
                <div v-if="cancelacion" class="form-group">
                    <label for="cancel">Fecha y hora próximo contacto:</label>
                    <Calendar :disabled="razonipas == ''" style="width: 100%;" dateFormat="dd/mm/yy" v-model="cancelacion" id="cancel" showTime hourFormat="24"/>
                </div>
                <div class="form-group">
                    <label for="motivo">Motivo:</label>
                    <textarea :disabled="razonipas == ''" class="form-control" v-model="motivo" id="motivo"></textarea>
                </div>
                <div class="form-group">
                    <p>Si no se indica una razón solo se modificará la descripción en PWGS</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-3">
                <button style="width:100%;background:green;border:0px"
                    @click="crearevento(eventoamodificar,tipoamodificar); difuminado = ''"
                    class=" btn btn-primary btn-sm">Si</button>
            </div>
            <div class="col-md-3">
                <button style="width:100%;background:red;border:0px"
                    @click="confirmacionvisible = false;recargar();this.diaactual = this.$refs.vuecal.view.startDate.getDate(); difuminado = ''"
                    class="btn btn-primary btn-sm">Cancelar</button>
            </div>
        </div>
    </Dialog>
</template>
<script>
import serviciodatosvisitasvisita from '../servicios/datos/visitas/visita_datos.vue';
import Dialog from 'primevue/dialog';
import VueCal from 'vue-cal'; 
import Calendar from 'primevue/calendar';
import Presupuestos from '../servicios/presupuestos/presupuestos.vue';
import 'vue-cal/dist/vuecal.css';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import planningcomunicaciones from '../servicios/planning/planning_comunicaciones.vue';
import trabajosrealizadosoperarios from '../servicios/trabajosrealizados/TrabajosRealizadosOperario.vue';
import OverlayPanel from 'primevue/overlaypanel';
import { PwgsApi } from '../../../services/PwgsApi';
export default ({
    props: ['id', 'servicio','operarios','operariosseleccionados','especioperario','cambios','fechacal'],
    components: {
        Dialog, VueCal, Calendar,Textarea,Button, trabajosrealizadosoperarios, planningcomunicaciones,OverlayPanel,Presupuestos,
        'servicio-datos-visitas-visita': serviciodatosvisitasvisita
        
    },
    data() {
        return {
            
            cargandoOver:[],
            spinner:true,
            difuminado:'filter:blur(4px)',
            mesactual:new Date().getMonth(),
            minevent: "150",
            titulo: '',
            eventoamostrar: '',
            nomodificar:'0',
            infoevento: '',
            confirmacionvisible:false,
            prioritaria:'0',
            editable: { title: false, drag: true, resize: true, delete: true, create: false },
            visible: false,
            miseventos: [],
            eventos: [],
            editar: false,
            local: 'es-ES',
            color: ["blue", "green", "orange", "red", "purple", "yellow", "silver", "aqua", "maroon","lime", "navy", "fuchsia", "olive", "aqua"],
            vistaactiva: "day",
            colorboton: "normal",
            altura:'50vw',
            splitDays: [],
            anyoactual:'',
            aux: [],
            trabajosrealizadostexto: '',
            trabajospendientestexto:'',
            mostrarpop: false,
            fechainicioeditar: new Date(),
            fechafineditar: new Date(),
            selectedDate: new Date(),
            trabajos:false,
            nevisible: false,
            eventoacrear: new Date(),
            operarioseleccionado: '',
            especialidadseleccionada: '',
            fechafin: '',
            especialidadesdos: [],
            equipos: [],
            equiposanyadir:[],
            equiposseleccionado: [],
            clickparanavegar: true,
            descripcionvisitas: '',
            nombreseleccionado:'',
            clientedescripcion: [],
            nombreequipo: '',
            operariosingular: '',
            colorbotondos: "normal",
            colorbotontres: "normal",
            colorbotoncuatro: "normal",
            mostrarcomunicaciones: false,
            tipoamodificar:'',
            finalizar: false,
            presupuestos: false,
            operariossplit: [],
            diaactual: '',
            idservicioevento: '',
            idvisitaevento:'',
            propiedadescalendario:'',
            documentosrellenar: [],
            documentosanyadir: [],
            eventoamodificar:'',
            url: '',
            textoprueba: "hola",
            pepe: "(",
            mes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            auxiliarsplit:[],
            inicio:true,
            diasemanal : '',
            messemanal : '',
            añosemanal: '',
            colorfestivo:'',
            nombrefestividad: '',
            noesguardiaofestivo: true,
            descripcionevento: '',
            citasactivas: 0,
            citasconfirmar: 0,
            citasfinalizadas: 0,
            cargarcalendario: true,
            alturatimecel: 28,
            mitimestep: 30,
            nombreevento: '',
            ocultar:false,
            descripcionbloq: '',
            idvisitaaux: '',
            ideventoaux: '',
            eventopabloaux: '',
            pabloevento: '',
            pabloevent: '',  
            distanciaevento: '',
            chatsvisita: '',
            fechacalddos:null,
            ipas:false,
            razones:[],
            subrazones:[],
            razonipas:'',
            subrazonipas:'',
            valoresipas:[],
            motivo:'',
            cancelacion:'',
            id_visita:0,
            id_servicio:0,
        }
    },
    computed:{
        disabledViews(){
            if(Array.isArray(this.operariosseleccionados) && this.operariosseleccionados.length > 0){                
                return ["years", "year","week"];
            }else{
                return ["years", "year", "week"];
            }
        },
         
    },
    methods: {
        cargar() {
            this.descripcionvisitas = '';
            this.eventos = [];
            this.aux = [];
            this.splitDays = [];
            this.local = localStorage.getItem("locale");
            if (this.local == "cat") { this.local = "ca"; }
            //this.cargareventos();
            this.cargarespecialidades();
        },
        async comprobarChats(idvis) {
            
            const api = new PwgsApi();
            let aux = await api.get('chat-pwgs?id_visita=' + idvis);
            this.chatsvisita = aux.n_total_registros;
            console.log("chatsvisita", this.chatsvisita);
        },
        mostrar(evento, event) {
            this.pabloevento = evento;
            this.pabloevent = event;
            if(event.title == 'VACACIONES'){
                console.log("event", event);
                this.descripcionbloq = event.content;
                    this.$refs.opb.toggle(evento);
                    this.$refs.opb.alignOverlay(evento);
            }else if (event.title != 'GUARDIA' && event.title != 'OCUPADO' && event.title != 'BLOQUEADO' && event.title != 'RESERVA') {
                this.idservicioevento = event.idservicio;
                this.idvisitaevento = event.id_visita;                
                this.cargarvisitaevento(event.idservicio, event.id);
                this.comprobarChats(event.id);
                let horainicio = event.fecha.getHours();
                horainicio = horainicio +1;
                if(horainicio<9){horainicio="0"+horainicio}
                let minutoinicio = event.fecha.getMinutes();
                if (minutoinicio < 9) { minutoinicio = "0" + minutoinicio }
                let horafin = event.fechafin.getHours();
                horafin = horafin +1;
                if(horafin<9){horafin="0"+horafin}
                let minutofin = event.fechafin.getMinutes();
                if (minutofin < 9) { minutofin = "0" + minutofin }
                this.mostrarpop = true;
                this.nombreevento = event.class;
                this.distanciaevento = event.distancia;
                console.log("event", event);
                this.descripcionevento ="Inicio: " + horainicio + ":" + minutoinicio + " Fin: " + horafin + ":" + minutofin + "  " + this.decode_utf8(event.content)
               /**/ this.$refs.op.show(evento);
                console.log("this.$refs.op", this.$refs.op);
                this.$refs.op.alignOverlay(evento)
            }else if(event.title == 'BLOQUEADO'){
                this.descripcionbloq = event.content;
                this.$refs.opb.toggle(evento);
                this.$refs.opb.alignOverlay(evento)
            }else{
                event.dragable = false;
                event.resizable = false;
                event.background = false;
            }
        },
        abrirop(){
        if(this.$refs.op && !this.$refs.op.visible){
                this.$refs.op.show();
            }
            if(this.$refs.opb && !this.$refs.opb.visible){
                this.$refs.opb.show();
            }
        },
        cerrarop(){
            if(this.$refs.op && this.$refs.op.visible){
                this.$refs.op.hide();
            }
            if(this.$refs.opb && this.$refs.opb.visible){
                this.$refs.opb.hide();
            }
        },
        calculareventosactivos(eventos) {
            let contadoreventosnormales = 0;
            for (let i = 0; i < eventos.length; i++) {
                if (eventos[i].color == "#ffe88c") {
                    contadoreventosnormales++;
                }
            }
            return contadoreventosnormales;
        },
        calculareventosfinalizados(eventos) {
            let contadoreventosnormales = 0;
            for (let i = 0; i < eventos.length; i++) {
                if (eventos[i].color == "#e8eff4") {
                    contadoreventosnormales++;
                }
            }
            return contadoreventosnormales;
        },
        calculareventosporconfirmar(eventos) {
            let contadoreventosnormales = 0;
            for (let i = 0; i < eventos.length; i++) {
                if (eventos[i].color == "#ff4646") {
                    contadoreventosnormales++;
                }
            }
            return contadoreventosnormales;
        },
        confirmarevento(evento,tipo) {
            this.id_visita = evento.event.id_visita;
            this.id_servicio = evento.event.idservicio;
            this.comprobarIpas(evento);
            this.difuminado = "filter:blur(4px)";
            this.$refs.op.hide();
            if(tipo=='arrastra'){
                var inicioaux = new Date((evento.event.start).getTime()+30*60000);
                var finaux = new Date((evento.event.end).getTime()+30*60000);
                var auxnewdate = new Date((evento.newDate).getTime()+30*60000);
                evento.event.start = inicioaux;
                evento.event.end = finaux;
                evento.newDate = auxnewdate;
            }
            this.eventoamodificar = null;
            this.tipoamodificar = null;
            this.confirmacionvisible = true;
            this.eventoamodificar = evento;
            this.tipoamodificar = tipo;
        },
         async finalizarvisita() {
            this.$parent.$parent.$parent.toggleFinalizar();
        },
        agregarequipo() { 
            if(this.equipos.length>=1){
            let subidadatos = { nombre: this.nombreequipo, id_equipo: this.equiposseleccionado };
                this.equiposanyadir.push(subidadatos); 
            }
        },
        toggleTrabajos() {
            this.trabajos = !this.trabajos;
            if (this.trabajos == true) { this.altura = '80vw'; this.colorboton = "green" }
            else if (this.trabajos == false && this.editar == true && this.mostrarcomunicaciones == true || this.trabajos == false && this.editar == false && this.mostrarcomunicaciones == true || this.trabajos == false && this.editar == true && this.mostrarcomunicaciones == false ) { this.altura = '80vw'; this.colorboton = "normal" }
            else { this.altura = '50vw'; this.colorboton = "normal";}
        },
        toggleEditar() {
            this.editar = !this.editar;
            if (this.editar == true) { this.altura = '80vw'; this.colorbotondos = "green" }
            else if (this.editar == false && this.trabajos == true && this.mostrarcomunicaciones == true || this.editar == false && this.trabajos == false && this.mostrarcomunicaciones == true || this.editar == false && this.trabajos == true && this.mostrarcomunicaciones == false) { this.altura = '80vw'; this.colorbotondos = "normal" }
            else { this.altura = '50vw'; this.colorbotondos = "normal"; }
        },
        togglepresupuestos() {
            this.presupuestos = !this.presupuestos;
        },
        async finVisita() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/finalizar-visita/:id_visita
            //trabajosrealizadostexto trabajospendientestexto
            try {
                const api = new PwgsApi();
                let subidadatos = { trabajos_realizados_cita: this.trabajosrealizadostexto, trabajos_pendientes_cita: this.trabajospendientestexto }
                await api.put("planning-pwgs/" + this.idservicioevento + "/finalizar-visita/" + this.eventoamostrar.visita.idvisitador, subidadatos);
                this.cargar();
                this.visible = false;
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async cargarfestivos() {
            this.events = [];
            this.eventosaeliminar = [];
            const api = new PwgsApi();
            this.anyoactual = this.anyoactual.replace(" ","")
            let aux = await api.get('festivos/' + this.anyoactual);
            this.listadofestivos = aux.datos;
        },
        comprobarfestivos() {
            let auxfestivos = false;
            if(this.listadofestivos && this.listadofestivos.length>0){
            for (let i = 0; i < this.listadofestivos.length; i++) {
                if (new Date(this.listadofestivos[i].fecha).getFullYear() == this.anyoactual && new Date(this.listadofestivos[i].fecha).getMonth() + 1 == this.mesactual && new Date(this.listadofestivos[i].fecha).getDate() == this.diaactual) {
                    document.getElementsByClassName("vuecal__flex vuecal__title")[0].style.background = '#28a745';
                    this.nombrefestividad = "Festivo " + this.listadofestivos[i].nombre;
                    auxfestivos = true;
                }
            }
            if (auxfestivos == false) {
                document.getElementsByClassName("vuecal__flex vuecal__title")[0].style.background = '#e5e5e5';
                this.nombrefestividad = " ";
            }
            }
        },
        togglecalen(event) {
            this.$refs.calenddos.toggle(event);
        },
        toggleFinalizar() {
            this.finalizar = !this.finalizar;
            if (this.finalizar == true) {
                this.colorbotoncuatro = "green";
            }
            else
            {
                this.colorbotoncuatro = "normal";
            }       
        },
        toggleComunicaciones() {
            this.mostrarcomunicaciones = !this.mostrarcomunicaciones;
            if (this.mostrarcomunicaciones == true) { this.altura = '80vw'; this.colorbotontres = "green" }
            else if (this.mostrarcomunicaciones == false && this.trabajos == true && this.editar == true || this.mostrarcomunicaciones == false && this.trabajos == false && this.editar == true || this.mostrarcomunicaciones == false && this.trabajos == true && this.editar == false) { this.altura = '80vw'; this.colorbotontres = "normal" }
            else { this.altura = '50vw'; this.colorbotontres = "normal"; }
        },
        removerequipo(equip) {
            for (let i = 0; i < this.equiposanyadir.length; i++)
            { if (equip.id_equipo == this.equiposanyadir[i].id_equipo) { this.equiposanyadir.splice(i, 1); } }
        },
        async eliminarVisita(evento) {
            //DELETE  modulos/pwgsapi/index.php/planning-pwgs/eliminar-visita/:id_visita
            const api = new PwgsApi();
            try{
                await api.delete("planning-pwgs/" + this.idvisitaevento + "/eliminar-visita/" + evento.id_visita);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Cita borrada correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                this.cargareventos();
            }
        },
        recargar(){
            this.cargareventos('recargar');
        },
        async cargarprops() {
         
            
            const api = new PwgsApi();
            let fecha_hora = "?fecha=" + this.anyoactual + "-" + this.mesactual + "-" + this.diaactual;
            let propsoper = await api.get('planning-pwgs/' + this.$props.id + '/formulario-visita' + fecha_hora);
            var operarios = propsoper.operarios_planning;
            for (let dc of Object.values(operarios)) {
                for (let i = 0; i < this.splitDays.length; i++) {
                    if (dc.id == this.splitDays[i].id) {
                        this.splitDays[i].carga = dc.carga;
                        this.splitDays[i].guardia = dc.guardia;
                        this.splitDays[i].interpwgs = dc.interpwgs;
                    }
                }
            }
            
        },
        async cargarpropiedades() {
            //GET /modulos/pwgsapi/index.php/planning-pwgs/137728/formulario-visita
            const api = new PwgsApi();
            this.propiedadescalendario = await api.get('planning-pwgs/0/formulario-visita');
        },
        async cargarespecialidades() {
            //get  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/especialidades
            const api = new PwgsApi();
            const datos = await api.get("especialidades");
            this.especialidades = datos.datos;
        },
        cargarsplit() {
            this.splitDays = [];
            let subidadatoss = [];           
            let i = 0; 
            for (let operario of Object.entries(this.$props.operarios)) {
                let clicktocall = "window.open('sip:" + operario[1].telefono1 + "','_self'); return false;"
                subidadatoss = { id: operario[1].idoperario, class: operario[1].idoperario, label: operario[1].nombre, split: operario[1].idoperario, color: this.color[i], carga: operario[1].carga, clicktocall: clicktocall, observaciones: operario[1].observaciones_operario, preferente: operario[1].preferente_operario, hide: false, autovisita: operario[1].autovisita }
                this.splitDays.push(subidadatoss);
                i++;
            }
        },
        sumarDias(dia, mes, año, diasASumar) {
            // Dividimos la fecha en día, mes y año
            // Creamos una nueva fecha usando el constructor Date
            let fechaOriginal = new Date(año, mes - 1, dia); // mes - 1 porque los meses en JS van de 0 (enero) a 11 (diciembre)
            // Sumamos los días
            fechaOriginal.setDate(fechaOriginal.getDate() + diasASumar);
            // Formateamos la nueva fecha al formato "día-mes-año"
            let nuevoDia = fechaOriginal.getDate().toString().padStart(2, '0');
            let nuevoMes = (fechaOriginal.getMonth() + 1).toString().padStart(2, '0'); // +1 porque el mes empieza desde 0
            let nuevoAño = fechaOriginal.getFullYear();
            return `${nuevoDia}-${nuevoMes}-${nuevoAño}`;
        },
        async cargareventos(motivo) {
            const dia = this.diaactual;

if (motivo !== 'recargar') {
  this.spinner = true;
  //this.difuminado = "filter:blur(4px)";
}

setTimeout(async () => {
  if (dia !== this.diaactual) return;

  /* ========= INICIALIZACIÓN ========= */
  if (this.inicio) {
    this.splitDays = Object.values(this.$props.operarios).map((op, i) => ({
      id: op.idoperario,
      class: op.idoperario,
      label: op.nombre,
      split: op.idoperario,
      color: this.color[i],
      carga: op.carga_operario,
      clicktocall: `window.open('sip:${op.telefono1}','_self'); return false;`,
      observaciones: op.observaciones_operario,
      preferente: op.preferente_operario,
      hide: false,
      autovisita: op.autovisita
    }));
    this.inicio = false;
  }

  if (this.anyoactual.endsWith(")")) {
    this.anyoactual = this.anyoactual.slice(0, -1);
  }

  /* ========= RANGO FECHAS ========= */
  let rango;
  if (this.$refs.vuecal.isWeekView) {
    const [d, m, a] = this.sumarDias(this.diaactual, this.mesactual, this.anyoactual, 6)
      .split('-').map(Number);

    Object.assign(this, {
      diasemanal: d,
      messemanal: m,
      añosemanal: a
    });

    rango = {
      start: `${this.anyoactual}-${String(this.mesactual).padStart(2, '0')}-${String(this.diaactual).padStart(2, '0')}T00:00:00`,
      end: `${a}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}T23:59:00`
    };
  } else {
    rango = {
      start: `${this.anyoactual}-${String(this.mesactual).padStart(2, '0')}-${String(this.diaactual).padStart(2, '0')}T00:00:00`,
      end: `${this.anyoactual}-${String(this.mesactual).padStart(2, '0')}-${String(this.diaactual).padStart(2, '0')}T23:59:00`
    };
  }

  /* ========= API ========= */
  const api = new PwgsApi();
  this.miseventos = await api.post("planning-pwgs", rango);
  this.eventos = [];

  /* ========= MAP OPERARIOS ========= */
  const operariosMap = new Map(
    Object.values(this.$props.operarios).map(op => [op.idoperario, op])
  );

  const normalizarHora = h => (h.length < 5 ? `0${h}` : h);

  const crearFecha = (offset, hora) => {
    const [d, m, a] = this.sumarDias(
      this.diaactual,
      this.mesactual,
      this.anyoactual,
      offset
    ).split('-').map(Number);

    return new Date(`${a}-${m}-${d}T${hora}`);
  };

  /* ========= EVENTOS ========= */
  for (const ev of Object.values(this.miseventos)) {
    const operario = operariosMap.get(ev.id_operario);
    if (!operario) continue;

    const background = ev.rendering === "background";
    const tipo = ev.title;
    const split = operario.idoperario;

    if (["GUARDIA", "OCUPADO", "BLOQUEADO", "VACACIONES", "RESERVA"].includes(ev.title)) {
      ev.color = "";
    }

    /* === EVENTOS SEMANALES (DOW) === */
    if (this.$refs.vuecal.isWeekView && ev.dow?.length) {
      ev.start = normalizarHora(ev.start);
      ev.end = normalizarHora(ev.end);

      for (const day of ev.dow) {
        const offset = Number(day) - 1;
        const start = crearFecha(offset, ev.start);
        const end = crearFecha(offset, ev.end);

        this.nuevoevento(
          ev.title, start, end, ev.color, ev.id,
          ev.description, ev.iconos, ev.id_servicio,
          background, tipo, split, ev.id,
          ev.poblacion, ev.cp, ev.color_km, ev.distancia
        );
      }
      continue;
    }

    /* === EVENTOS NORMALES === */
    let start = new Date(ev.start).addHours(-1);
    let end = new Date(ev.end).addHours(-1);

    if (ev.title === "GUARDIA" || (ev.title === "OCUPADO" && ev.dow)) {
      ev.start = normalizarHora(ev.start);
      ev.end = normalizarHora(ev.end);

      const base = new Date(this.$refs.vuecal.view.startDate)
        .addHours(4)
        .toISOString().split('T')[0];

      start = new Date(`${base}T${ev.start}`).addHours(-1);
      end = new Date(`${base}T${ev.end}`).addHours(-1);
    }

    this.nuevoevento(
      ev.title, start, end, ev.color, ev.id,
      ev.description, ev.iconos, ev.id_servicio,
      background, tipo, split, ev.id,
      ev.poblacion, ev.cp, ev.color_km, ev.distancia,
      ev.fecha_original,ev.fecha_fin_original
    );
  }

  if (motivo !== 'recargar') {
    this.difuminado = "";
    this.spinner = false;
  }

}, 800);
            
        },
         async crearevento(event,tipo) { 
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/mover-visita/:id_visita
            const api = new PwgsApi();

            if(tipo == 'arrastra'){
                let fechaInicioAux = new Date();
                let fechainicioauxd = new Date();
                if(event.event.fecha_original && event.event.fecha_fin_original){
                    fechaInicioAux = new Date(event.event.fecha_original);
                    fechaInicioAux.setHours(  new Date(event.event.fecha).getHours(),  new Date(event.event.fecha).getMinutes(),  new Date(event.event.fecha).getSeconds(),);
                    fechainicioauxd = fechaInicioAux;
                }
                else{
                    fechainicioauxd = new Date(event.originalEvent.start);
                }
                let segundos = ((new Date(event.newDate).getTime() - fechainicioauxd.getTime()) / 1000);
                let subidadatosdos = { id_operario: event.newSplit,tipo:tipo,segundos:segundos };
                if(this.ipas && this.razones.length>0){                
                    if (this.razonipas != '') {
                        subidadatosdos.razones_cancelacion_cita_mensaje = this.razonipas;
                        subidadatosdos.motivo_cancelacion_cita = this.motivo;
                        subidadatosdos.razones_cancelacion_cita_contrato_mensaje = this.subrazonipas;
                        if (this.cancelacion) {
                            var fecha = this.convertir(this.cancelacion).split(', ')[0];
                            var hora = this.convertir(this.cancelacion).split(', ')[1];
                            subidadatosdos.fecha_cancelacion_proximo_contacto_cita = fecha;
                            subidadatosdos.hora_cancelacion_proximo_contacto_confirmacion_cita = hora;
                        }
                        for (let valor of Object.values(this.valoresipas)) {
                            if (valor.nombre == 'PROFESSION_NU_cancelacion_cita') {
                                subidadatosdos.PROFESSION_NU_cancelacion_cita = valor.valor;
                            }
                            if (valor.nombre == 'fecha_unix_visita_origen') {
                                subidadatosdos.fecha_unix_visita_origen = valor.valor;
                            }
                        }
                    }
                }
                try {
                    await api.put("planning-pwgs/" + this.$props.id + "/mover-visita/" + event.event.id_visita, subidadatosdos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Evento modificado correctamente', life: 2000 });
                    this.confirmacionvisible = false; // <-- Se cierra SOLO si tiene �xito
                    this.cargareventos();
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    this.cargareventos();
                }

            }
            if (tipo == 'redimensiona') {
                try {
                    let segundos = ((new Date(event.event.end).getTime() - new Date(event.originalEvent.end).getTime()) / 1000);
                    let subidadatos = { tipo: tipo, segundos: segundos };
                    if(this.ipas && this.razones.length>0){                
                        if (this.razonipas != '') {
                            subidadatos.razones_cancelacion_cita_mensaje = this.razonipas;
                            subidadatos.motivo_cancelacion_cita = this.motivo;
                            subidadatos.razones_cancelacion_cita_contrato_mensaje = this.subrazonipas;
                            if (this.cancelacion) {
                                fecha = this.convertir(this.cancelacion).split(', ')[0];
                                hora = this.convertir(this.cancelacion).split(', ')[1];
                                subidadatos.fecha_cancelacion_proximo_contacto_cita = fecha;
                                subidadatos.hora_cancelacion_proximo_contacto_confirmacion_cita = hora;
                            }
                            for (let valor of Object.values(this.valoresipas)) {
                                if (valor.nombre == 'PROFESSION_NU_cancelacion_cita') {
                                    subidadatos.PROFESSION_NU_cancelacion_cita = valor.valor;
                                }
                                if (valor.nombre == 'fecha_unix_visita_origen') {
                                    subidadatos.fecha_unix_visita_origen = valor.valor;
                                }
                            }
                        }
                    }
                    await api.put("planning-pwgs/" + event.event.idservicio + "/mover-visita/" + event.event.id_visita, subidadatos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Evento movido correctamente', life: 2000 });
                    this.confirmacionvisible = false; // <-- Se cierra SOLO si tiene �xito
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    this.cargareventos();
                }
            }          
            //this.confirmacionvisible = false;
        },
        prueba(event) {
            if (event.view == "week")
            {
               
               // this.splitDays = [];
                this.editable.drag = false;
                this.editable.resize = false;
            }
            if (event.view == "month") {
                this.totalcitas(this.anyoactual, this.mesactual);
            }
            if(event.view == "day") {
               // this.refresh();
              //this.splitDays = this.aux;
                this.editable.drag = true;
                this.editable.resize = true;
            }
        },
        refresh() {
            this.diaactual = this.diaactual - 1;

            setTimeout(() => {
                this.diaactual = this.diaactual + 1;

            }, 500);
        },
        decode_utf8(s) {
            try{
                return decodeURIComponent(escape(s)); 
            }
            catch(error){
                console.log(error);
                return s;
            }
        },
        nuevoevento(titulo, inicio, fin, color, id, description, iconos, idservicio, background, tipo, split, id_visita,poblacion,cp,color_km,distancia,fecha_original,fecha_fin_original) {
            let mievento = { title: titulo, start: new Date(inicio), end: new Date(fin), color: color, id: id, content: this.decode_utf8(description), fecha: inicio, fechafin: fin, iconos: iconos, idservicio: idservicio, background: background, class: tipo, split: split, draggable: true, deletable: true, id_visita: id_visita, poblacion: poblacion, cp: cp, color_km: color_km,distancia:distancia };
            if (titulo == "FESTIVO") {
                mievento = { title: titulo, start: inicio, end: fin, color: color, id: id, content: description, fecha: inicio, fechafin: fin, iconos: iconos, idservicio: idservicio, background: background, class: tipo, split: split, draggable: true, deletable: true, id_visita: id_visita, poblacion:poblacion, cp:cp, color_km:color_km,distancia:distancia };
            }
            else{
                mievento = { title: titulo, start: new Date(inicio), end: new Date(fin), color: color, id: id, content: description, fecha: inicio, fechafin: fin, iconos: iconos, idservicio: idservicio, background: background, class: tipo, split: split, draggable: true, deletable: true, id_visita: id_visita, poblacion: poblacion, cp: cp, color_km: color_km,distancia:distancia,fecha_original:fecha_original,fecha_fin_original:fecha_fin_original };
            } 
            this.eventos.push(mievento);
        },
        async parteoperarioemail() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ficha-operario/:id_visita
            const api = new PwgsApi();
            await api.put("planning-pwgs/" + this.idservicioevento + "/enviar-ficha-operario/" + this.eventoamostrar.visita.idvisitador);
        },
        onEventClick(event) {
            this.eventopabloaux = event;
            this.eventoamostrar = '';
            this.titulo = event.title + " || " + new Date(event.fecha).toLocaleDateString("es-ES", { day: 'numeric' }) + "-" + new Date(event.fecha).toLocaleDateString("es-ES", { month: 'short' }) + "-" + new Date(event.fecha).toLocaleDateString("es-ES", { year: 'numeric' }) + " " + new Date(event.fecha).addHours(1).toLocaleTimeString("es-ES", { hour: '2-digit', minute: '2-digit' }) + "-" + new Date(event.fechafin).addHours(1).toLocaleTimeString("es-ES", { hour: '2-digit', minute: '2-digit' });
            this.infoevento = event.content;
            this.trabajos = false;
            this.fechainicioeditar = event.fecha;
            this.fechafineditar = event.fechafin;
            this.altura = '50vw';
            if (event.title != 'GUARDIA' && event.title != 'OCUPADO' && event.title != 'BLOQUEADO' && event.title != 'VACACIONES' && event.title != 'RESERVA') {
                this.visible = true;
            }
            this.editar = false;
            this.finalizar = false;
            this.colorbotondos = "normal";
            this.colorboton = "normal";
            this.colorbotontres = "normal";
            this.colorbotoncuatro = "normal"; 
            this.cargarvisitaevento(event.idservicio, event.id);
        },
        cerrarvisible() {
            this.visible = false;
           // this.mostrar(this.pabloevento, this.pabloevent);
           // this.onEventClick(this.eventopabloaux);

        },
         async smsoperario() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-operario/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.idservicioevento + "/enviar-sms-operario/" + this.eventoamostrar.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al operario correctamente', life: 2000 });
            }
             catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async smsasegurado() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-asegurado/:id_visita
            const api = new PwgsApi();
            try {
                await api.put("planning-pwgs/" + this.idservicioevento + "/enviar-sms-asegurado/" + this.eventoamostrar.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al asegurado correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async steasegurado() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ste-firma/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-ste-firma/" + this.eventoamostrar.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Ste enviado correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async cargarvisitaevento(idservicio, idvisita) {
            //GET  modulos/pwgsapi/index.php/servicios/:id/visitas
            const api = new PwgsApi();
            let datos; 
            this.idvisitaaux = idservicio;
            this.ideventoaux = idvisita;
            if (idservicio){
                while(this.cargandoOver.length > 0){
                    this.cargandoOver.splice(0,this.cargandoOver.length);
                }
                this.cargandoOver.push(idservicio+idvisita);
                datos = await api.get('servicios/' + idservicio+ '/visitas/'+idvisita);   
                if(this.cargandoOver.includes(idservicio+idvisita)){
                    this.eventoamostrar = datos[0];
                    console.log("eventoamostrar", this.eventoamostrar);
                    this.operariosingular = this.eventoamostrar.visita.operarios_idoperario;                
                    this.cargandoOver.pop(idservicio+idvisita);
                }             
                
            }
        },
        splitcheck() {
            if (this.$refs.vuecal.isDayView == false) {
                this.splitDays = [];
            }
          //  else { this.splitDays = this.aux }
        },
        async pedidosservicio() {
            //GET  modulos/pwgsapi/index.php/servicios/:id/pedidos
        },
        abrirventana() {
         //   let urlaux = localStorage.getItem('direccion');
            this.url = this.eventoamostrar.fichas_operario.completa_generico;
            window.open(this.url);
        },
       async confirmarvisita(event) {
           // modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/confirmar-visita/:id_visita
            let fechainicio = new Date(event.visita.fecha).toLocaleDateString('es-ES');
            let fechafin = new Date(event.visita.fecha_fin).toLocaleDateString('es-ES');
            let formatomini = new Date(event.visita.fecha_inicio).getMinutes();
            if (formatomini < 10) formatomini = "0" + formatomini;
            let formatominf = new Date(event.visita.fecha_fin).getMinutes();
            if (formatominf < 10) formatominf = "0" + formatominf;
            let subidadatos = { fecha_cita_inicio: fechainicio, fecha_cita_fin: fechafin, hora_cita_fin: event.visita.hora_fin, hora_cita_inicio: event.visita.hora };
            const api = new PwgsApi();
           await api.put('planning-pwgs/' + this.idservicioevento + '/confirmar-visita/' + event.visita.idvisitador, subidadatos);
        },
        cambiartexto(texto) {
            this.textoprueba = this.textoprueba + texto;
        },
       async modificarVisita(evento, fechini, fechfin, descrevento, modificar, prioritaria) {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/modificar-visita/:id_visita
            let fechainicio = new Date(fechini).toLocaleDateString('es-ES');
            let fechafin = new Date(fechfin).toLocaleDateString('es-ES');
            let formatohorai = new Date(fechini).getHours();
            if (formatohorai < 10) formatohorai = "0" + formatohorai;
            let formatohoraf = new Date(fechfin).getHours();
            if (formatohoraf < 10) formatohoraf = "0" + formatohoraf;
            let formatomini = new Date(fechini).getMinutes();
            if (formatomini < 10) formatomini = "0" + formatomini;
            let formatominf = new Date(fechfin).getMinutes();
            if (formatominf < 10) formatominf = "0" + formatominf;
            let horainicio = formatohorai + ":" + formatomini + ":00";
            let horafin = formatohoraf + ":" + formatominf + ":00";

            const api = new PwgsApi();
            let subidadatos = { fecha_cita_inicio: fechainicio, fecha_cita_fin: fechafin, hora_cita_inicio: horainicio, hora_cita_fin: horafin, descripcion_cita: descrevento, prioritaria_cita: prioritaria, no_modificar_cita: modificar };
            if(this.ipas && this.razones.length>0){                
                if (this.razonipas != '') {
                    subidadatos.razones_cancelacion_cita_mensaje = this.razonipas;
                    subidadatos.motivo_cancelacion_cita = this.motivo;
                    subidadatos.razones_cancelacion_cita_contrato_mensaje = this.subrazonipas;
                    if (this.cancelacion) {
                        var fecha = this.convertir(this.cancelacion).split(', ')[0];
                        var hora = this.convertir(this.cancelacion).split(', ')[1];
                        subidadatos.fecha_cancelacion_proximo_contacto_cita = fecha;
                        subidadatos.hora_cancelacion_proximo_contacto_confirmacion_cita = hora;
                    }
                    for (let valor of Object.values(this.valoresipas)) {
                        if (valor.nombre == 'PROFESSION_NU_cancelacion_cita') {
                            subidadatos.PROFESSION_NU_cancelacion_cita = valor.valor;
                        }
                        if (valor.nombre == 'fecha_unix_visita_origen') {
                            subidadatos.fecha_unix_visita_origen = valor.valor;
                        }
                    }
                }
            }
            try {
                await api.put("planning-pwgs/" + this.idservicioevento + "/modificar-visita/" + evento.visita.idvisitador, subidadatos);
                this.visible = false;
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                this.cargareventos();
            }         
        },
        sacarmes() {
            const { viewTitle, view } = this.$refs.vuecal;

/* === AÑO === */
this.anyoactual = viewTitle.slice(-4);

/* === DÍA === */
this.diaactual = String(view.startDate.getDate()).padStart(2, '0');

/* === MES === */
const meses = {
  Enero: "01",
  Febrero: "02",
  Marzo: "03",
  Abril: "04",
  Mayo: "05",
  Junio: "06",
  Julio: "07",
  Agosto: "08",
  Septiembre: "09",
  Octubre: "10",
  Noviembre: "11",
  Diciembre: "12"
};

this.mesactual = Object.keys(meses).find(m => viewTitle.includes(m))
  ? meses[Object.keys(meses).find(m => viewTitle.includes(m))]
  : this.mesactual;
        },
        cargarevs(event) {
            if (this.$refs.vuecal.isMonthView == true) {
                let aux;
                aux = new Date(event).getDate();
                if (aux < 10) { aux = "0" + aux; }
                this.diaactual = aux;


            }

        },
        eventoclick(event) {
            if (this.$refs.vuecal.isWeekView == true) {
                this.$refs.vuecal.currentView = 'Week';
            }
            this.nomodificar = '0';
            this.prioritaria = '0';
            this.equiposseleccionado = '';
            this.equiposanyadir = [];
            this.clientedescripcion = [];
            //this.clienteseleccionado = '';
            //this.cargarequipos();
            this.especialidadesdos = [];
            this.operarioseleccionado = event.split;
            this.cargarpropiedades(this.operarioseleccionado, event);
            //this.cargarespecialidadoperarios();
            if (this.$refs.vuecal.isMonthView == false) {
                this.nevisible = true;
            }
        },
        async totalcitas(anyo, mes) {
            //planning-pwgs/0/visitas-mes-dia?fecha=2024-09-01
            this.eventos = [];
            const api = new PwgsApi();
            let datos = await api.get("planning-pwgs/0/visitas-mes-dia?fecha=" + parseInt(anyo) + "-" + parseInt(mes) + "-01");
            if(parseInt(mes)<10){
                mes = "0" + mes;
            }
            let festivos = await api.get('festivos/' + parseInt(anyo));

            for (let visita of Object.entries(datos)) {
                let subidadatos = [];
                subidadatos.start = new Date(visita[0]);
                subidadatos.end = new Date(visita[0]).addHours(4);
                subidadatos.title = visita[0];
                subidadatos.activas = visita[1].activas;
                subidadatos.confirmar = visita[1].confirmar;
                subidadatos.finalizadas = visita[1].finalizadas;
                this.eventos.push(subidadatos);
                
            }
            for (let i = 0; i < festivos.datos.length; i++) {
                let subidadatos = [];

                subidadatos.start = new Date(festivos.datos[i].fecha);
                subidadatos.end = new Date(festivos.datos[i].fecha).addHours(4);
                subidadatos.festivostitle = festivos.datos[i].nombre;
                subidadatos.festivos = "F";
                this.eventos.push(subidadatos);
            }
        },
        async cargarformato() {
            const api = new PwgsApi();
            let franjas = await api.get('parametros-pwgs/franjas_planning');
            if (franjas.franjas_planning) {
                this.alturatimecel = 14;
                this.mitimestep = 15;
            }
        },
        async comprobarIpas(evento){
            //console.log("COMPROBAR SERVICIO_IPAS",'servicios/'+evento.event.idservicio+'/sistema');
            this.razones = [];
            const api = new PwgsApi();
            var sistema = await api.get('servicios/'+evento.event.idservicio+'/sistema');
            sistema == "IPAS_WS" ? this.ipas = true : this.ipas = false;
            if(this.ipas){
                const api = new PwgsApi();
                this.valoresipas = await api.post('planning-pwgs/'+evento.event.idservicio+'/formulario-modifica-visita/'+evento.event.id_visita);
                try{
                    for(let valor of Object.values(this.valoresipas)){
                        if(valor.nombre == 'razones_cancelacion_cita_mensaje'){
                            this.razones = Object.values(valor.valores);
                        }
                    }
                }catch(error){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        async obtenersubrazones(){
            this.subrazones = [];
            if(this.razonipas== ''){
                console.log("NO HAY RAZON IPAS");
            }else{
                //console.log("COMPROBAR SUBRAZONES IPAS",this.id_visita);
                const api = new PwgsApi();
                const resp = await api.post('planning-pwgs/'+this.id_servicio+'/formulario-modifica-visita/'+this.id_visita,{razones_cancelacion_cita_mensaje:this.razonipas});
                var fecha = '';
                var hora = '';
                for(let res of resp){
                    if(res.nombre == 'razones_cancelacion_cita_contrato_mensaje'){
                        this.subrazones = Object.values(res.valores);
                    }
                    if(res.nombre == 'fecha_cancelacion_proximo_contacto_cita'){
                        fecha = res.valor;
                    }
                    if(res.nombre == 'hora_cancelacion_proximo_contacto_confirmacion_cita'){
                        hora = res.valor;
                    }
                }
                //console.log("COMPROBAR SUBRAZONES IPAS",fecha);
                if(fecha!= ''){
                    var fechatotal = this.convertirAFecha(fecha+' '+hora);
                    this.cancelacion = fechatotal; 
                }
            }
        },
        convertir(fecha){
            return fecha.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        },
        convertirAFecha(fechaStr) {
            // Asume que el formato es "dd/mm/yyyy hh:mm"
            let [fecha, hora] = fechaStr.split(' ');
            let [dia, mes, año] = fecha.split('/');
            let [horas, minutos] = hora.split(':');
            
            return new Date(año, mes - 1, dia, horas, minutos);
        },
    },
    mounted() {
        this.cargarformato();
        this.cargarpropiedades();
        this.sacarmes();
        this.cargar();
        this.cargarfestivos();
        this.mesactual = this.mesactual + 1;
        setTimeout(() => {
            this.diaactual = this.diaactual - 1;
            this.diaactual = this.diaactual + 1;
        }, 500);
        console.log("vuecalandario", this.$refs.vuecal);
        this.$refs.vuecal.now
    },
    watch: {
        diaactual() {
           // var cels = document.getElementsByClassName('vuecal__cell');
            const vuecal = this.$refs.vuecal;
            const operariosSeleccionados = new Set(this.$props.operariosseleccionados);

            if (vuecal.isMonthView) {
                this.totalcitas(this.anyoactual, this.mesactual);
                const title = document.querySelector('.vuecal__flex.vuecal__title');
                if (title) title.style.background = '#e5e5e5';
                this.nombrefestividad = '';
            } else {
                this.cargareventos('dia');
                // this.$parent.reiniciaroperarios();
                this.comprobarfestivos();

                const sinFiltro = operariosSeleccionados.size === 0;

                this.splitDays.forEach(day => {
                    day.hide = !sinFiltro && !operariosSeleccionados.has(day.id);
                });
            }
            this.cargarprops();
        },
        descripcionvisitas() {
            if (this.descripcionvisitas.length < 30) this.miclase = "p-invalid";
            else this.miclase = "";
        },
        operariosseleccionados(value) {
            if(value == ''){
                this.vistaactiva = "day";
                this.cargareventos();
            }
            for (let i = 0; i < this.splitDays.length; i++)
            {
                  this.splitDays[i].hide = true;
                  if (this.$props.operariosseleccionados.length < 1 && this.$props.cambios == false) { this.splitDays[i].hide = false;  }
                    for (let j = 0; j < this.$props.operariosseleccionados.length; j++){
                        if (this.splitDays[i].id == this.$props.operariosseleccionados[j])
                        {
                            this.splitDays[i].hide = false;
                         }
                  }
            }
            for (let k = 0; k < this.splitDays.length; k++) { 
                if (this.splitDays[k].hide == false) {
                    this.operariossplit.push(this.splitDays[k]);
                }
            }
            var alguno = false;
            for (let i = 0; i < this.operariossplit.length; i++) {
                if (this.operariossplit[i].hide == false) {
                    alguno = true;
                }
            }
            if(!alguno){
                this.ocultar = true;
            }else{
                this.ocultar = false;
            }
        },
        mesactual() {
            if (this.$refs.vuecal.isMonthView==true){
                this.totalcitas(this.anyoactual, this.mesactual);
            }
        },
        fechacal() {
            
            this.anyoactual = String(this.fechacal.getFullYear());
            this.mesactual = this.fechacal.getMonth() + 1;
            this.diaactual = this.fechacal.getDate();
            this.selectedDate = this.fechacal;
            
                    
        },
        anyoactual() {
            this.cargarfestivos();
            this.comprobarfestivos();
        },
        fechacalddos() {

            this.anyoactual = String(this.fechacalddos.getFullYear());
            this.mesactual = this.fechacalddos.getMonth() + 1;
            this.diaactual = this.fechacalddos.getDate();
            this.selectedDate = this.fechacalddos;

        },
        razonipas(){
            this.obtenersubrazones();
        },
    }
})
</script>
<style>
.vuecal__cell-events-count{
    color: black;
    background-color: rgba(255, 255, 0, 0);
    height: 15px;
};
.vuecal__title button {
    color: rgb(0, 0, 0);
}
.vuecal--month-view .vuecal__cell {
    height: 70px;
    margin-top: 0px !important;
}
.vuecal__today-btn {
    font-size: 0.8em;
    border-radius: 5px;
    color: rgb(0, 0, 0);
}
.vuecal__today-btn:hover {
    background-color: rgb(0, 105, 217);
    border-radius: 4px;
    color: rgb(255, 255, 255);
}
.vuecal__arrow--next {
    right: 38%;
}
.vuecal__arrow--prev {
    left: 36%;
}
.vuecal__today-btn {
    right: 90%;
}
.table td, .table th {
	padding: .75rem;
	vertical-align: middle;
	border-top: 0px solid #dee2e6;
}

.vuecal .vuecal__split-days-headers{
    align-items:flex-start;
}
.vuecal__time-column{
    margin-top:5em !important;
}
.vuecal__split-days-headers {
    text-align: center;
    height: 10em !important;
}
/*.vuecal__title-bar{
    /*margin-bottom:2%;
}
.vuecal__body{
    /*margin-top:2%;
}
.vuecal__time-cell-line {
    padding-top: 5.5em !important;
}*/
.operarioseleccionado{
    width:70%;
}
.GUARDIA{
      background:
    #fff7f0 
    repeating-linear-gradient(
      -45deg,
      rgba(255, 87, 87, 0.25),
      rgba(255, 87, 87, 0.25) 5px,
      rgba(255, 255, 255, 0) 5px,
      rgba(255, 255, 255, 0) 15px
    ) !important;
    color:rgb(216, 27, 96) !important;    
}
.OCUPADO {
    background:
        #fff7f0 
    repeating-linear-gradient(
        -45deg,
            rgba(102, 126, 231, 0.25),
            rgba(102, 126, 231, 0.25), 5px,
            rgba(255, 255, 255, 0) 5px,
            rgba(255, 255, 255, 0) 15px) 
            !important;
    color: rgb(30, 27, 216) !important;
}
.BLOQUEADO {
    background:
        #fff7f0 repeating-linear-gradient(
            -45deg,
            rgba(71, 98, 104, 0.25),
            rgba(71, 98, 104, 0.25), 5px,
            rgba(255, 255, 255, 0) 5px,
            rgba(255, 255, 255, 0) 15px) !important;
    color: rgb(71, 98, 104) !important;
}
.VACACIONES {
    background:
        #fff7f0 repeating-linear-gradient(-45deg,
            rgba(0, 204, 0, 0.25),
            rgba(0, 204, 0, 0.25), 5px,
            rgba(255, 255, 255, 0) 5px,
            rgba(255, 255, 255, 0) 15px) !important;
    color: rgb(18, 110, 18) !important;
}
.RESERVA {
    background:rgb(253, 126, 20) !important;
}
.vuecal__cell-split{
    border: 0.5px solid;
    border-color:lightgray;
}

.p-datepicker-other-month {
color: #bbb !important; /* Color más claro */
opacity: 0.6; /* Opcional, para dar apariencia atenuada */
}

/* Opcional: cambia el fondo al pasar el mouse */
.p-datepicker-other-month:hover {
  background-color: #f0f0f0;
}

.vuecal__cell{
    margin-top:-23px !important;
}
.vuecal__flex .vuecal__cell-content{
    display:block;
}
.inputfecha{
    width: 10rem !important;
}
.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index:1000;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
        
}
.vuecal__now-line{
    margin-top: -56px;
}
.day-split-header{
    padding-bottom:20px !important;
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>